import React from 'react';
import styled from 'styled-components';
import { Trans } from 'react-i18next';
import Price from '@ingka/price';
import designTokens from '@ingka/variables/design-tokens';
import { FormattedPrice } from '../services/Appointment/model';
import useTranslation from '../hooks/useTranslation';

interface TextWithPriceProps {
  price: FormattedPrice;
  textKey: string;
  alignment?: 'left' | 'right';
  textColor?: string;
}

const Container = styled.span<{
  $alignment: 'left' | 'right';
  $color?: string;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${({ $alignment }) =>
    $alignment === 'left' ? 'flex-start' : 'flex-end'};
  white-space: pre-wrap;
  &&& span {
    font-weight: ${designTokens.fontWeightRegular};
    color: ${({ $color }) => $color || 'inherit'};
  }
  flex-wrap: wrap;
`;

const DualPricesContainer = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const PricePart: React.FC<{ price: FormattedPrice }> = ({ price }) => {
  const { mainPrice, secondaryPrice } = price;
  return secondaryPrice ? (
    <DualPricesContainer>
      <Price {...mainPrice} fixedSize size="small" subtle />
      &nbsp;
      <Price {...secondaryPrice} fixedSize size="small" subtle />
    </DualPricesContainer>
  ) : (
    <Price {...mainPrice} fixedSize size="small" subtle />
  );
};

const TextWithPrice: React.FC<TextWithPriceProps> = ({
  price,
  textKey,
  alignment = 'left',
  textColor,
}) => {
  const { i18n } = useTranslation();
  return (
    <Container $alignment={alignment} $color={textColor}>
      <Trans
        i18n={i18n}
        i18nKey={textKey}
        components={{
          price: <PricePart price={price} />,
        }}
      />
    </Container>
  );
};

export default TextWithPrice;
